(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mt-home-hero-slider"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('mt-home-hero-slider')) {
    customElements.define('mt-home-hero-slider', class extends HTMLElement {
      connectedCallback() {
        if (this.mtInitialized) return;
        this.mtInitialized = true;
        this.mtController = new AbortController();
        this.mtSlides = Array.from(this.querySelectorAll('[data-mt-slide]'));
        this.mtDots = Array.from(this.querySelectorAll('[data-mt-dot]'));
        this.mtIndex = Math.max(0, this.mtSlides.findIndex((mtSlide) => mtSlide.classList.contains('mt-radhalle-hero__campaign-slide--active')));
        this.mtInterval = Math.max(4000, Number(this.dataset.mtInterval) || 7000);
        this.mtReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.mtAutoplay = this.dataset.mtAutoplay === 'true' && !this.mtReducedMotion;
        this.mtEditorPaused = false;
        this.mtInView = true;
        this.mtPointerX = 0;
        this.mtPointerY = 0;
        this.mtIgnoreClick = false;
        this.dataset.mtAutoplay = String(this.mtAutoplay);
        this.dataset.mtPaused = 'true';

        const mtOptions = { signal: this.mtController.signal };

        this.querySelector('[data-mt-prev]')?.addEventListener('click', () => this.mtShow(this.mtIndex - 1, true), mtOptions);
        this.querySelector('[data-mt-next]')?.addEventListener('click', () => this.mtShow(this.mtIndex + 1, true), mtOptions);
        this.mtDots.forEach((mtDot) => {
          mtDot.addEventListener('click', () => this.mtShow(Number(mtDot.dataset.mtDot), true), mtOptions);
        });

        this.addEventListener('mouseenter', () => this.mtPause(), mtOptions);
        this.addEventListener('mouseleave', () => this.mtPlay(), mtOptions);

        this.addEventListener('pointerdown', (mtEvent) => {
          if (mtEvent.isPrimary === false) return;
          this.mtPointerX = mtEvent.clientX;
          this.mtPointerY = mtEvent.clientY;
        }, mtOptions);

        this.addEventListener('pointerup', (mtEvent) => {
          if (mtEvent.isPrimary === false) return;
          const mtDistanceX = mtEvent.clientX - this.mtPointerX;
          const mtDistanceY = mtEvent.clientY - this.mtPointerY;
          if (Math.abs(mtDistanceX) < 50 || Math.abs(mtDistanceX) <= Math.abs(mtDistanceY) * 1.2) return;
          this.mtIgnoreClick = true;
          this.mtShow(this.mtIndex + (mtDistanceX < 0 ? 1 : -1), true);
          window.setTimeout(() => {
            this.mtIgnoreClick = false;
          }, 0);
        }, mtOptions);

        this.addEventListener('pointercancel', () => {
          this.mtIgnoreClick = false;
        }, mtOptions);

        this.addEventListener('click', (mtEvent) => {
          if (!this.mtIgnoreClick) return;
          mtEvent.preventDefault();
          mtEvent.stopPropagation();
          this.mtIgnoreClick = false;
        }, { capture: true, signal: this.mtController.signal });

        this.mtVisibilityHandler = () => {
          if (document.hidden) this.mtPause();
          else this.mtPlay();
        };
        document.addEventListener('visibilitychange', this.mtVisibilityHandler, mtOptions);

        this.mtBlockSelectHandler = (mtEvent) => {
          const mtSlide = mtEvent.target.closest?.('[data-mt-slide]');
          if (!mtSlide || !this.contains(mtSlide)) return;
          const mtSelectedIndex = this.mtSlides.indexOf(mtSlide);
          if (mtSelectedIndex < 0) return;
          this.mtEditorPaused = true;
          this.mtShow(mtSelectedIndex, false);
          this.mtPause();
        };
        document.addEventListener('shopify:block:select', this.mtBlockSelectHandler, mtOptions);

        this.mtBlockDeselectHandler = (mtEvent) => {
          const mtSlide = mtEvent.target.closest?.('[data-mt-slide]');
          if (!mtSlide || !this.contains(mtSlide)) return;
          this.mtEditorPaused = false;
          this.mtPlay();
        };
        document.addEventListener('shopify:block:deselect', this.mtBlockDeselectHandler, mtOptions);

        if ('IntersectionObserver' in window) {
          this.mtObserver = new IntersectionObserver((mtEntries) => {
            this.mtInView = mtEntries[0]?.isIntersecting === true;
            if (this.mtInView) this.mtPlay();
            else this.mtPause();
          }, { threshold: 0.3 });
          this.mtObserver.observe(this);
        }

        this.mtShow(this.mtIndex, false);
        this.mtPlay();
      }

      disconnectedCallback() {
        this.mtPause();
        this.mtObserver?.disconnect();
        this.mtController?.abort();
        this.mtInitialized = false;
      }

      mtShow(mtNextIndex, mtUserInitiated) {
        if (this.mtSlides.length < 1) return;
        this.mtIndex = (mtNextIndex + this.mtSlides.length) % this.mtSlides.length;

        this.mtSlides.forEach((mtSlide, mtIndex) => {
          const mtActive = mtIndex === this.mtIndex;
          const mtLink = mtSlide.querySelector('[data-mt-slide-link]');
          mtSlide.classList.toggle('mt-radhalle-hero__campaign-slide--active', mtActive);
          mtSlide.setAttribute('aria-hidden', String(!mtActive));
          if (mtLink?.tagName === 'A') mtLink.setAttribute('tabindex', mtActive ? '0' : '-1');
        });

        this.mtDots.forEach((mtDot, mtIndex) => {
          const mtActive = mtIndex === this.mtIndex;
          mtDot.classList.toggle('mt-radhalle-hero__campaign-progress-button--active', mtActive);
          mtDot.setAttribute('aria-pressed', String(mtActive));
        });

        if (mtUserInitiated) this.mtPlay();
      }

      mtPause() {
        window.clearInterval(this.mtTimer);
        this.mtTimer = null;
        this.dataset.mtPaused = 'true';
      }

      mtPlay() {
        this.mtPause();
        if (
          !this.mtAutoplay ||
          this.mtEditorPaused ||
          !this.mtInView ||
          document.hidden ||
          this.matches(':hover') ||
          this.mtSlides.length < 2
        ) return;

        this.dataset.mtPaused = 'false';
        this.mtTimer = window.setInterval(() => this.mtShow(this.mtIndex + 1, false), this.mtInterval);
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
